import { systemsConstants } from "../_constants";

const initialState = {
    data: [],
    loading: false
}

export function systems(state = initialState, action) {
    switch (action.type) {
        case systemsConstants.SYSTEMS_LOADING:
            return {
                ...state,
                loading: true,
                data: []
            };
        case systemsConstants.SYSTEMS_LOADED:
            return {
                ...state,
                loading: false,
                data: action.data
            };
        case systemsConstants.SYSTEMS_ERROR:
            return {
                ...state,
                loading:false,
                data: []
            };
        default:
            return state;
    }
}